import { Breakpoints } from "@angular/cdk/layout";
import { Pipe, PipeTransform } from '@angular/core';

const BreakpointConfig = {
  'mobile': [
    Breakpoints.XSmall,
    Breakpoints.Small,
    // Breakpoints.Medium
  ],
  'desktop': [
    Breakpoints.Large,
    Breakpoints.XLarge
  ]
};

@Pipe({
  name: 'breakpointAlias',
  standalone: true
})
export class BreakpointAliasPipe implements PipeTransform {
  transform(alias: keyof typeof BreakpointConfig): any {
    if (!BreakpointConfig[alias]) {
      return false;
    }
    return BreakpointConfig[alias];
  }
}
